module.exports = __webpack_public_path__ + "static/media/contabilidade-s.2562420d.jpg";